export default {
  profile_page: {
    profile: {
      title: 'Profile',
      form: {
        email_label: 'Email Address',
        update_email_button: 'Update Email',
      },
    },
    password: {
      title: 'Password',
      form: {
        current_pass_label: 'Current password',
        new_pass_label: 'New Password',
        repeat_pass_label: 'Confirm New Password',
        update_pass_button: 'Update Password',
      },
      actions: {
        update_pass: {
          message_1: 'Are you sure to update your password?',
          message_2: 'Caution',
          confirm: 'Yes, change password',
          cancel: 'No, cancel',
          success: {
            title: 'Profile',
            message: 'Password updated successfully.',
          },
          error: {
            title: 'Profile',
            message: 'An error occurred while updating your password.',
          },
        },
        update_profile: {
          message_1: 'Are you sure to update your profile?',
          message_2: 'Caution',
          confirm: 'Yes, update',
          cancel: 'No, cancel',
          success: {
            title: 'Profile',
            message: 'Profile successfully updated.',
          },
          error: {
            title: 'Profile',
            message: 'An error occurred while updating your profile.',
          },
        },

      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/account/profile.js